import { DEPART_DIRECTION } from '../../constants';
import * as types from './types';

const INITIAL_STATE = {
    departTripId: undefined,
    returnTripId: undefined,
    destinationPlaceId: undefined,
    originPlaceId: undefined,
    departDate: undefined,
    returnDate: undefined,
    direction: DEPART_DIRECTION,
    inputs: {
        current: {
            origin: undefined,
            originPlaceId: undefined,
            destination: undefined,
            destinationPlaceId: undefined,
            passengers: undefined,
        },
    },
    serverBatchId: undefined,
    queryParams: undefined,
};

function removeSearchParams(state) {
    return {
        ...INITIAL_STATE,
        inputs: { ...state.inputs },
    };
}

function setSearchParams(state, action) {
    const { payload: searchParams } = action;

    return {
        ...state,
        ...searchParams,
    };
}

function setQueryParams(state, action) {
    const { payload: queryParams } = action;
    return {
        ...state,
        queryParams: {
            ...state.queryParams,
            ...queryParams,
        },
    };
}

function setInputParams(state, action) {
    const { payload: inputParams } = action;

    return {
        ...state,
        inputs: {
            ...state.inputs,
            current: {
                ...inputParams,
            },
        },
    };
}

function setDirection(state, action) {
    const {
        payload: direction,
    } = action;

    if (!direction) {
        return state;
    }

    return {
        ...state,
        direction,
    };
}

function setDepartTripId(state, action) {
    const {
        meta: departTripId,
    } = action;

    if (!departTripId) {
        return {
            ...state,
            departTripId: undefined,
        };
    }

    return {
        ...state,
        departTripId,
    };
}

function setReturnTripId(state, action) {
    const {
        meta: returnTripId,
    } = action;

    if (!returnTripId) {
        return {
            ...state,
            returnTripId: undefined,
        };
    }

    return {
        ...state,
        returnTripId,
    };
}

function removeDepartTripId(state) {
    const {
        departTripId: _departTripId,
        ...newState
    } = state;

    return newState;
}

function removeReturnTripId(state) {
    const {
        returnTripId: _returnTripId,
        ...newState
    } = state;

    return newState;
}

function setUserPlaceId(state, action) {
    const {
        meta: { direction },
        payload: { placeId, input },
    } = action;
    return {
        ...state,
        inputs: {
            ...state.inputs,
            [placeId]: input,
            current: {
                ...state.inputs.current,
                [`${direction}PlaceId`]: placeId,
            },
        },
    };
}

function setOriginUserInput(state, action) {
    const {
        payload: input,
    } = action;

    return {
        ...state,
        inputs: {
            ...state.inputs,
            current: {
                ...state.inputs.current,
                origin: input,
            },

        },
    };
}

function setPassengersInput(state, action) {
    const {
        payload: input,
    } = action;

    return {
        ...state,
        inputs: {
            ...state.inputs,
            current: {
                ...state.inputs.current,
                passengers: input,
            },

        },
    };
}

function setDestinationUserInput(state, action) {
    const {
        payload: input,
    } = action;

    return {
        ...state,
        inputs: {
            ...state.inputs,
            current: {
                ...state.inputs.current,
                destination: input,
            },
        },
    };
}

function setServerBatchId(state, action) {
    const {
        meta: serverBatchId,
    } = action;

    return {
        ...state,
        serverBatchId,
    };
}

const reducerFunctions = {
    [types.REMOVE_SEARCH_PARAMS]: removeSearchParams,
    [types.SET_SEARCH_PARAMS]: setSearchParams,
    [types.SET_QUERY_PARAMS]: setQueryParams,
    [types.SET_INPUT_PARAMS]: setInputParams,
    [types.SET_DIRECTION]: setDirection,
    [types.SET_DEPART_TRIP_ID]: setDepartTripId,
    [types.SET_RETURN_TRIP_ID]: setReturnTripId,
    [types.REMOVE_DEPART_TRIP_ID]: removeDepartTripId,
    [types.REMOVE_RETURN_TRIP_ID]: removeReturnTripId,
    [types.SET_USER_PLACE_ID]: setUserPlaceId,
    [types.SET_ORIGIN_USER_INPUT]: setOriginUserInput,
    [types.SET_PASSENGERS_INPUT]: setPassengersInput,
    [types.SET_DESTINATION_USER_INPUT]: setDestinationUserInput,
    [types.SET_SERVER_BATCH_ID]: setServerBatchId,
};

export {
    INITIAL_STATE,
};
export default function reducer(state = INITIAL_STATE, action = {}) {
    if (!Object.prototype.hasOwnProperty.call(reducerFunctions, action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
